import { Injectable } from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogService} from '@shared/services/dialog-service';
import {DialogModel} from '@shared/models/dialog.model';

@Injectable({
  providedIn: 'root'
})
export class CreateEatWorkflowCommandHandler implements IPlatformCommandHandler{

  constructor(private dialogService: DialogService) { }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const dialogModel = DialogModel.create(
      'Create New E.A.T Workflow',
      'CreateEatWorkflowDialogComponent',
      {},
      '565px',
      '565px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(response => {
      if (response.action === 'OK') {
        if (response.data.input) {
          const title = response.data.input['title'];
          const description = response.data.input['description'];
          const singleExecution = response.data.input['singleExecution'];
          command.fieldValues['Title'] = title;
          command.fieldValues['Description'] = description;
          command.fieldValues['SingleExecution'] = singleExecution;
          handler.executeCommand(command);
        }
      }
    });
    return false;
  }
}
